import gql from 'graphql-tag';

export const MutationCreatePaymentIntent = gql`mutation create_payment_intent($input: CreatePaymentIntentInput!) {
  createPaymentIntent(input: $input) {
    clientSecret
    status
    message
  }
}`;
